// src/data/exercises/L2_05.js

const accountOptions = [
  '買掛金', '商品', '前払金', '仮払消費税', '仮受消費税'];

export const L2_05 = {
  title: '簿記　3級（第218-5回）',
  questions: [
    {
      id: 'q1',
      type: 'JOURNAL_ENTRY',
        content: {

      parts: [
        { type: 'ruby', text: '愛知商事', ruby: 'あいちしょうじ' },
        { type: 'ruby', text: '株式会社', ruby: 'かぶしきがいしゃ' },
        { type: 'text', value: 'より' },
        { type: 'ruby', text: '商品', ruby: 'しょうひん' },
        { type: 'text', value: '￥4,840,000（うち' },
        { type: 'ruby', text: '消費税額', ruby: 'しょうひぜいがく' },
        { type: 'text', value: '￥440,000）を' },
        { type: 'ruby', text: '仕入', ruby: 'しい' },
        { type: 'text', value: 'れ、' },
        { type: 'ruby', text: '代金', ruby: 'だいきん' },
        { type: 'text', value: 'のうち￥1,500,000は' },
        { type: 'ruby', text: '以前', ruby: 'いぜん' },
        { type: 'text', value: 'に' },
        { type: 'ruby', text: '支払', ruby: 'しはら' },
        { type: 'text', value: 'っていた' },
        { type: 'ruby', text: '内金', ruby: 'うちきん' },
        { type: 'text', value: 'を' },
        { type: 'ruby', text: '充当', ruby: 'じゅうとう' },
        { type: 'text', value: 'し、' },
        { type: 'ruby', text: '残額', ruby: 'ざんがく' },
        { type: 'text', value: 'は' },
        { type: 'ruby', text: '掛', ruby: 'か' },
        { type: 'text', value: 'けとした。ただし、' },
        { type: 'ruby', text: '当社', ruby: 'とうしゃ' },
        { type: 'text', value: 'は' },
        { type: 'ruby', text: '商品販売取引', ruby: 'しょうひんはんばいとりひき' },
        { type: 'text', value: 'に' },
        { type: 'ruby', text: '関', ruby: 'かん' },
        { type: 'text', value: 'して、' },
        { type: 'ruby', text: '販売', ruby: 'はんばい' },
        { type: 'text', value: 'のつど、' },
        { type: 'ruby', text: '売上原価', ruby: 'うりあげげんか' },
        { type: 'text', value: 'に' },
        { type: 'ruby', text: '振', ruby: 'ふ' },
        { type: 'text', value: 'り' },
        { type: 'ruby', text: '替', ruby: 'か' },
        { type: 'text', value: 'える' },
        { type: 'ruby', text: '方法', ruby: 'ほうほう' },
        { type: 'text', value: '（' },
        { type: 'ruby', text: '売上原価対立法', ruby: 'うりあげげんかたいりつほう' },
        { type: 'text', value: '）で' },
        { type: 'ruby', text: '記帳', ruby: 'きちょう' },
        { type: 'text', value: 'している。' }
    ]

      },
      table: {
        options: accountOptions,
      },
      // Đáp án có 1 dòng Nợ và 2 dòng Có
      answer: [
        { debitAccount: '商品', debitAmount: 4400000, creditAccount: '前払金', creditAmount: 1500000 },
        { debitAccount: '仮払消費税', debitAmount: 440000, creditAccount: '買掛金', creditAmount: 3340000 },
              ],
       // Giải thích chi tiết khi trả lời ĐÚNG (có định dạng)
      explanation_correct: {
        parts: [
          { type: 'text', value: '商品￥4,840,000（うち消費税額￥440,000）を仕入れ、 \n' },
          { type: 'text', value: '①商品を仕入れなので、「仕入」と記入したいが、売上原価対立法なので \n' },
          { type: 'text', value: '「仕入」ではなく、商品が増加（プラス）します。 \n' },
          { type: 'styled', value: '商品の増加（プラス）は借方（左・Ｄｒ）に記入します。 \n\n', color: 'red', bold: true },
          { type: 'text', value: '商品￥4,840,000（うち消費税額￥440,000）を仕入れ、 \n' },
          { type: 'text', value: '②仕入れの消費税なので、仮払消費税が増加（プラス）します。\n' },
          { type: 'styled', value: '仮払消費税の増加（プラス）は借方（左・Ｄｒ）に記入します。\n\n', color: 'red', bold: true },
          { type: 'text', value: '以前に支払っていた内金を充当し、\n' },
          { type: 'text', value: '③以前に支払っていた内金は、前払金になります。前払金の増加（プラス）です。 \n' },
          { type: 'styled', value: '前払金の増加（プラス）は貸方（右・Ｃｒ）に記入します。\n\n', color: 'red', bold: true },
          { type: 'text', value: '残額は掛けとした。 \n' },
          { type: 'text', value: '④仕入れの掛けですので、買掛金になります。買掛金の増加（プラス）です。\n' },
          { type: 'styled', value: '買掛金の増加（プラス）は貸方（右・Ｃｒ）に記入します。\n\n', color: 'red', bold: true },
        
        ]
      },

      // Gợi ý 2 cấp độ khi trả lời SAI
      hints: {
        account: [
          // Gợi ý lần 1, 2
`商品￥4,840,000（うち消費税額￥440,000）を仕入れ、
①商品を仕入れなので、「仕入」と記入したいが、売上原価対立法なので
「仕入」ではなく、商品が増加（プラス）します。
商品の金額は、4,840,000－消費税額440,000＝？
　　       
商品￥4,840,000（うち消費税額￥440,000）を仕入れ、
②仕入れの消費税なので、仮払消費税が増加（プラス）します。
　
以前に支払っていた内金を充当し、
　③以前に支払っていた内金は、前払金になります。前払金の増加（プラス）です。
　　
残額は掛けとした。
　④仕入れの掛けですので、買掛金になります。買掛金の増加（プラス）です。

　　  `,
          // Gợi ý lần 3 (chi tiết hơn, có định dạng)
          {
           parts: [
          { type: 'text', value: '商品￥4,840,000（うち消費税額￥440,000）を仕入れ、 \n' },
          { type: 'text', value: '①商品を仕入れなので、「仕入」と記入したいが、売上原価対立法なので \n' },
          { type: 'text', value: '「仕入」ではなく、商品が増加（プラス）します。 \n' },
          { type: 'styled', value: '商品の増加（プラス）は借方（左・Ｄｒ）に記入します。 \n\n', color: 'red', bold: true },
          { type: 'text', value: '商品￥4,840,000（うち消費税額￥440,000）を仕入れ、 \n' },
          { type: 'text', value: '②仕入れの消費税なので、仮払消費税が増加（プラス）します。\n' },
          { type: 'styled', value: '仮払消費税の増加（プラス）は借方（左・Ｄｒ）に記入します。\n\n', color: 'red', bold: true },
          { type: 'text', value: '以前に支払っていた内金を充当し、\n' },
          { type: 'text', value: '③以前に支払っていた内金は、前払金になります。前払金の増加（プラス）です。 \n' },
          { type: 'styled', value: '前払金の増加（プラス）は貸方（右・Ｃｒ）に記入します。\n\n', color: 'red', bold: true },
          { type: 'text', value: '残額は掛けとした。 \n' },
          { type: 'text', value: '④仕入れの掛けですので、買掛金になります。買掛金の増加（プラス）です。\n' },
          { type: 'styled', value: '買掛金の増加（プラス）は貸方（右・Ｃｒ）に記入します。\n\n', color: 'red', bold: true },
        
        ]
          }
        ],
       
      },
    },
  ],
};